import {Component, ContentChildren, EventEmitter, Input, Output, QueryList, TemplateRef} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormWizardPaneComponent} from '@catuiform/components/form-wizard-pane/form-wizard-pane.component';
import {WizardOptions, WizardPane} from '@catuiform/types';
import {isNullOrUndefined} from 'util';

interface Wizard {
  introduction: WizardPane;
  properties: WizardPane;
  finishAndNextStep: WizardPane;
  options: WizardOptions;
}

/**
 * This component is a abstraction for using a WizardFormComponent for the specific usage to create a
 * unspecific Resource entity
 */
@Component({
  selector: 'cat-form-entity-wizard',
  templateUrl: './form-entity-wizard.component.html',
  styleUrls: ['./form-entity-wizard.component.scss'],
})
export class FormEntityWizardComponent {

  @Output() beforeDisplayProperties = new EventEmitter();
  @Output() validateProperties: EventEmitter<any> = new EventEmitter();
  @Output() completed: EventEmitter<any> = new EventEmitter();
  @Output() resetForm: EventEmitter<any> = new EventEmitter();

  @ContentChildren(FormWizardPaneComponent) panes: QueryList<FormWizardPaneComponent>;

  @Input() title: string;
  @Input() form: FormGroup;
  @Input() isCompleted: boolean;
  @Input() contentIntroduction: TemplateRef<any>;
  @Input() contentProperties: TemplateRef<any>;
  @Input() contentCompletion: TemplateRef<any>;
  @Input() resetAfterComplete = false;

  @Input()
  set labelButtonComplete(value: string) {
    if (!isNullOrUndefined(value)) {
      this.labels.buttons.complete = value;
    }
  }

  get labelButtonComplete(): string {
    return this.labels.buttons.complete;
  }

  labels = {
    buttons: {
      complete: 'Complete and Save the Feature',
    },
  };

  wizard: Wizard;

  constructor() {
    this.wizard = {
      introduction: {valid: true, touched: true, label: 'Start'},
      properties: {valid: false, touched: false, label: 'Properties'},
      finishAndNextStep: {valid: false, touched: false, label: 'Finish and follow up steps'},
      options: {panePosition: 'center'},
    };
  }

  afterIntroduction() {
    this.beforeDisplayProperties.emit();
    this.wizard.introduction.touched = true;
  }

  validatePropertiesForm($event) {
    this.validateProperties.emit($event);
  }

  completeProcess($event) {
    this.completed.emit($event);
    this.wizard.finishAndNextStep.touched = true;
    this.wizard.finishAndNextStep.valid = true;
  }

  resetFormResult() {
  }

  doResetForm() {
    this.resetForm.emit();
    this.isCompleted = false;
    this.form.reset();

    this.wizard = {
      introduction: {valid: true, touched: true, label: 'Start'},
      properties: {valid: false, touched: false, label: 'Properties'},
      finishAndNextStep: {valid: false, touched: false, label: 'Finish and follow up steps'},
      options: {panePosition: 'center'},
    };
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-entity-wizard/form-entity-wizard.component.ts